import { render } from "./receiptDetails.vue?vue&type=template&id=7372070a&scoped=true"
import script from "./receiptDetails.vue?vue&type=script&lang=js"
export * from "./receiptDetails.vue?vue&type=script&lang=js"

import "./receiptDetails.vue?vue&type=style&index=0&id=7372070a&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7372070a"]])

export default __exports__